import styled from "styled-components";

export const StyledSeperator = styled.div`
  border-bottom: 1px solid #00000027;
  margin: 20px 0;
`;

const Seperator = () => {
  return <StyledSeperator />;
};

export default Seperator;
